import { memo } from 'react';
import { EdgeProps, getBezierPath } from 'reactflow';
import { color } from '@uniquegood/realworld-studio-design';

function MissionQuestEdge({
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition
}: EdgeProps) {
  const [edgePath] = getBezierPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition
  });

  return (
    <path
      d={edgePath}
      style={{
        stroke: `${color.border_default_depressed}99`,
        strokeWidth: 1.2,
        strokeDasharray: '4 3',
        fill: 'none'
      }}
    />
  );
}

export default memo(MissionQuestEdge);
